module.exports = __webpack_public_path__ + "cb67e9974d0f4abac90ff779bd0ef6bf.svg";